// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"58":"840d836a","137":"cbc20b7d","149":"e112ca34","428":"c45a7d62","680":"2dff5dba","872":"d4e73e82","921":"a05eb4e0"}[chunkId] + ".chunk.js";
};